var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 11.02V1.9H10.165V11.02H7.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 16.055V13.965H10.165V16.055H7.6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 1.1875C7.66309 1.1875 7.125 1.72559 7.125 2.375V10.6875C7.125 11.3369 7.66309 11.875 8.3125 11.875H9.5C10.1494 11.875 10.6875 11.3369 10.6875 10.6875V2.375C10.6875 1.72559 10.1494 1.1875 9.5 1.1875H8.3125ZM8.3125 2.375H9.5V10.6875H8.3125V2.375ZM8.3125 13.0625C7.66309 13.0625 7.125 13.6006 7.125 14.25V15.4375C7.125 16.0869 7.66309 16.625 8.3125 16.625H9.5C10.1494 16.625 10.6875 16.0869 10.6875 15.4375V14.25C10.6875 13.6006 10.1494 13.0625 9.5 13.0625H8.3125ZM8.3125 14.25H9.5V15.4375H8.3125V14.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.9fed54f353b4b2ec218a8b6b86e1bcf9.svg";
export { ForwardRef as ReactComponent };